module.exports = __webpack_public_path__ + "img/box7.d7e99d8b.png";